import Vue from 'vue'
import Vuex from 'vuex'
import firebase from '../firebase'

Vue.use(Vuex);
Vue.use(firebase);

const state = {
  user: {
    name: '',
    meetingID: '',
    activeUser: false,
    request_control: false,
    uID: '',
    present: true
  },
  _isTrue: true,
  _isRequestingControl: false,
  userID: '',
  meetingID: '',
  _isActive: '',
  _activeUser: false,
  _present: true
};
const getters = {
  isTrue: function(state) {
    return state._isTrue;
  },
  isRequestingControl: function(state) {
    return state._isRequestingControl;
  },
  getUserData: function(state) {
    return state.user;
  },
  isActiveUser: function(state) {
    return state._activeUser;
  },


};
const mutations = {
  storeUserData: function(state, payload) {
    return state.userID = payload.userID
  },
  requestControl: function(state, bool) {
    return state._isRequestingControl = bool;
  },
  activeUser: function(state, bool) {
    return state._activeUser = bool;
  },
  requestRemoteControl: function(state, bool) {
    return state._activeUser = bool;
  },
  storeSessionDataMutation: function(state, payload) {
    return state.user = payload
  },
  toggle: function(state, bool) {
    return state._isTrue = bool;
  },
  updatePresence: function(state, bool) {
    return state._present = bool;
  }
};
const actions = {
  requestRemoteControl: function(context, payload) {
    let temp = !context.state._isRequestingControl;
    firebase.database.ref(payload.fbPath).set(temp);
  },
  getRequestRemoteControlFB: function(context) {
    firebase.database.ref('Session/' + state.user.meetingID + '/Users/' + state.user.userID + '/request_control').on("value", function(snapshot) {
      context.commit('requestRemoteControl', snapshot.val());
    })
  },
  requestControl: function(context) {
    let temp = !context.state._isTrue;
    firebase.database.ref('settings/setting').set(temp);
  },
  requestActiveUserListenerAction: function(context, payload) {
    firebase.database.ref(payload.activeUserPath).on("value", function(snapshot) {
      context.commit('activeUser', snapshot.val());
    })
  },

  requestControlListenerAction: function(context, payload) {
    firebase.database.ref(payload.fbPath).on("value", function(snapshot) {
      context.commit('requestControl', snapshot.val());
    })
  },
  lodUserData: function(context, payload) {
    // this.$store.
  },
  storeSessionDataAction: function(context, payload) {
    context.commit('storeSessionDataMutation', payload)
  },
  StopRemoteControl: function(context, payload) {
    let temp = !context.state._activeUser;
    firebase.database.ref(payload.fbPath).set(temp);
  },
  toggle: function(context) {
    let temp = !context.state._isTrue;
    firebase.database.ref('settings/setting').set(temp);
  },
  getFirebaseDatabase: function(context) {
    firebase.database.ref('settings/setting').on("value", function(snapshot) {
      context.commit('toggle', snapshot.val());
    })
  },
  logUsersPresence: function(context, payload) {
    // var myConnectionsRef = firebase.database.ref(payload.fbPath);
    var myConnectionsRef = firebase.database.ref(payload.fbPath);
    var lastOnlineRef = firebase.database.ref('users/joe/lastOnline');

    var connectedRef = firebase.database.ref('.info/connected');
    connectedRef.on('value', function(snap) {
      if (snap.val() === true) {
        context.commit('userPresent, snap')
        // We're connected (or reconnected)! Do anything here that should happen only if online (or on reconnect)
        var con = myConnectionsRef.push({
          startedAt: 'Now'
        });

        // When I disconnect, remove this device
        con.onDisconnect().remove();

        // Add this device to my connections list
        // this value could contain info about the device or a timestamp too
        con.set(true);

        // When I disconnect, update the last time I was seen online
        con.onDisconnect().set('laters');
      }
    });
  }

};

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
});